export default {
    wbl_category_column: {
        column_name: "Column Name",
        column_type: "Column Type",
        order_value: "Order Value"
      }
}